import z from 'zod'

export type UserSignUpRequest = {
  email: string
  firstName: string
  lastName: string
  company?: string
  type: string
  approvalStatus: string
  data?: Record<string, any>
  createdOn: Date
  respondedOn?: Date
}

export type UserSignUpRequestStatus = 'pending' | 'approved' | 'declined'

const userSignUpRequestTypeSchema = z.enum(['student'])
export type UserSignUpRequestType = z.infer<typeof userSignUpRequestTypeSchema>

export const createUserSignUpRequestRequestSchema = z.object({
  email: z.string().nonempty().email(),
  firstName: z.string(),
  lastName: z.string(),
  company: z.string().optional(),
  type: userSignUpRequestTypeSchema,
})

export type CreateUserSignUpRequestRequest = z.infer<typeof createUserSignUpRequestRequestSchema>

export const approveUserSignUpRequestRequestSchema = z.object({
  email: z.string().nonempty().email(),
})

export type ApproveUserSignUpRequestRequest = z.infer<typeof approveUserSignUpRequestRequestSchema>

export const declineUserSignUpRequestRequestSchema = z.object({
  email: z.string().nonempty().email(),
})

export type DeclineUserSignUpRequestRequest = z.infer<typeof declineUserSignUpRequestRequestSchema>
